import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "recompose";
import { Container, Dimmer, Loader } from "semantic-ui-react";
import { Navigation } from "src/components/Navigation";
import { withAuthorization } from "../../components/Session/withAuthorization";
import * as routes from "../../constants/routes";

const EditDatasource = React.lazy(
  () => import(/* webpackChunkName: "NewDatasource" */ "./EditDatasource")
);

const NewDatasourceForm = React.lazy(
  () => import(/* webpackChunkName: "EditDatasource" */ "./NewDatasourceForm")
);

const NewDatasourceComponent = ({
  authUser,
  orgId,
  history,
  match,
  usersStatus,
}: {
  [key: string]: any;
}) => (
  <React.Fragment>
    <Navigation />
    <Container className="main-container">
      <React.Suspense
        fallback={
          <Dimmer inverted={true}>
            <Loader size="small">Fetching data</Loader>
          </Dimmer>
        }
      >
        {match.params.datasourceId === routes.NEW && (
          <NewDatasourceForm
            authUser={authUser}
            orgId={orgId}
            history={history}
            usersStatus={usersStatus}
          />
        )}
        {match.params.datasourceId !== routes.NEW && (
          <EditDatasource
            authUser={authUser}
            orgId={orgId}
            usersStatus={usersStatus}
            history={history}
            datasourceId={match.params.datasourceId}
          />
        )}
      </React.Suspense>
    </Container>
  </React.Fragment>
);

const mapStateToProps = (state: any) => ({
  authUser: state.sessionState.authUser,
  orgId: state.sessionState.orgId,
  usersStatus: state.sessionState.usersStatus,
});

const authCondition = (authUser: any) => !!authUser;

const NewDatasource = compose(
  withAuthorization(authCondition),
  connect(mapStateToProps)
)(withRouter(NewDatasourceComponent));

export default NewDatasource;



// WEBPACK FOOTER //
// ./src/containers/Datasources/new.tsx